import React from 'react';
import bannersModule, { BannerTypes } from '@gin-betting/banners';

import { MultiCarousel } from 'components';
import Banner from '../Banner';
import useBannersCarousel from './useBannersCarousel';

import './bannersCarousel.scss';

type Props = BannerTypes.WithAvailableZoneProps;

const {
    hocs: { withAvailableZoneByAttributes },
} = bannersModule;

const BannersCarousel: React.FC<Props> = React.memo(
    ({ zoneId, zoneLocation }) => {
        const { interval, banners } = useBannersCarousel({ zoneId });

        if (!banners.length) {
            return null;
        }

        return (
            <div styleName="banners-slider ">
                <MultiCarousel slideWidth={300} interval={interval}>
                    {banners.map(banner => (
                        <Banner
                            key={banner.id!}
                            banner={banner}
                            zoneLocation={zoneLocation}
                        />
                    ))}
                </MultiCarousel>
            </div>
        );
    }
);

export default withAvailableZoneByAttributes(BannersCarousel);
